import React from 'react';
import PropTypes from 'prop-types';
import { Toggle, Input } from '../../../GlobalUI';

function AcutradeForm({
  enabled,
  acuTradeId,
  acuTradeApiKey,
  showKbb,
  onToggle,
  onChangeAcuTradeId,
  onChangeAcuTradeApiKey,
  onToggleKbb,
}) {
  return (
    <div className="setup-config-section">
      <div className="setup-config-header">TradeIns powered by Accu-Trade</div>
      <div className="setup-config-content">
        <p>Get firm offers instantly for trade-ins via Accu-Trade </p>
        <Toggle value={enabled} onToggle={onToggle} />
        {enabled && (
          <>
            <Input
              label="Accu-Trade Dealer ID*"
              value={acuTradeId}
              onChange={onChangeAcuTradeId}
            />
            <Input
              label="API Key*"
              value={acuTradeApiKey}
              onChange={onChangeAcuTradeApiKey}
            />
            <p>Show KBB Option</p>
            <Toggle value={showKbb} onToggle={onToggleKbb} />
          </>
        )}
      </div>
    </div>
  );
}

AcutradeForm.propTypes = {
  enabled: PropTypes.bool,
  acuTradeId: PropTypes.string,
  acuTradeApiKey: PropTypes.string,
  showKbb: PropTypes.bool,
  onToggle: PropTypes.func,
  onChangeAcuTradeId: PropTypes.func,
  onChangeAcuTradeApiKey: PropTypes.func,
  onToggleKbb: PropTypes.func,
};

export default AcutradeForm;
